import Webhook from "../models/Webhook";
import { ApiKeyOrGetter } from "./GeneralService";
import GeneralService from "./GeneralService";
import { Component } from "react";

export class WebhookService extends Component {
  public static registerWebhook(
    webhook: Webhook,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      "/webhooks/",
      JSON.stringify(webhook),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getWebhooks(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/webhooks/",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getWebhook(id: string, loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      `/webhooks/${id}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
